import * as types from "./mutation_types";

function state() {
    return {
        site: null,
        staticPage: {
            guarantee: {},
            payment: {},
            "document-personal": {},
            "document-confidentiality": {},
            "document-loyalty": {},
        },
        cart: {},
        city: "",
        banners: [],
        media: [],
        brands: [],
        catalog: [],
        catalogPagination: {},
        allCatalog: [],
        categories: [],
        faqSections: [],
        faqElements: [],
        stateFreeDeliveryModal: false,
        isLoadingCatalog: false,
        onlinePayment: false,
    };
}

const mutations = {
    [types.SET_DATA_SITE](state, data) {
        state.site = data;
    },
    [types.SET_STATIC_PAGE](state, { data, slug }) {
        state.staticPage[slug] = data;
    },
    [types.SET_CART](state, data) {
        state.cart = data;
    },
    [types.SET_CITY](state, { cityName }) {
        state.city = cityName;
        try {
            window.localStorage.setItem("ya_city_name", cityName);
        } catch (err) {
            console.error(err);
        }
        // TODO: изменить решение на cookie
    },
    [types.CHECK_CITY](state) {
        try {
            const cityName = window.localStorage.getItem("ya_city_name");

            if (cityName && cityName !== "undefined") {
                state.city = cityName;
                window.localStorage.setItem("ya_city_name", cityName);
            }
        } catch (err) {
            console.error(err);
            state.city = "Москва";
        }
    },
    [types.SET_BANNERS](state, { items }) {
        state.banners = items;
    },
    [types.SET_MEDIA](state, { items }) {
        state.media = items;
    },
    [types.SET_BRANDS](state, { items }) {
        state.brands = items;
    },
    [types.SET_CATALOG](state, { items, isPaginated }) {
        if (isPaginated) {
            state.catalog.push(...items);
        } else {
            state.catalog = items;
        }
    },
    [types.SET_CATALOG_BY_CATEGORY](state, { products }) {
        state.catalog = products;
    },
    [types.SET_CATALOG_PAGINATION](state, { currentPage, lastPage }) {
        state.catalogPagination = { currentPage, lastPage };
    },
    [types.SET_ALL_CATALOG](state, { items }) {
        state.allCatalog = items;
    },
    [types.SET_CATEGORIES](state, categories) {
        state.categories = categories.map((c) => {
            return { ...c, id: c.id.toString() };
        });
    },
    [types.SHOW_FREE_DELIVERY_MODAL](state) {
        state.stateFreeDeliveryModal = true;
    },
    [types.HIDE_FREE_DELIVERY_MODAL](state) {
        state.stateFreeDeliveryModal = false;
    },
    [types.SET_FAQ_SECTIONS](state, sections) {
        state.faqSections = sections;
    },
    [types.SET_FAQ_ELEMENTS](state, elements) {
        state.faqElements = elements;
    },
    [types.SET_ONLINE_PAYMENT_STATUS](state, status) {
        state.onlinePayment = status;
    },
    RESET_CART(state) {
        state.cart.number = 0;
        state.cart.productsList = false;
    },
    RESET_CATALOG(state) {
        state.catalog = [];
    },
    START_CATALOG_LOADING(state) {
        state.isLoadingCatalog = true;
    },
    STOP_CATALOG_LOADING(state) {
        state.isLoadingCatalog = false;
    },
};

const actions = {
    getDataSite({ commit }) {
        return this.rootApi.getDataSite().then((response) => {
            commit(types.SET_DATA_SITE, response);
        });
    },
    getStaticPage({ commit }, { slug }) {
        return this.rootApi.getStaticPage(slug).then((response) => {
            commit(types.SET_STATIC_PAGE, { data: response, slug: slug });
        });
    },
    getDefaultCity({ commit, state }) {
        commit(types.CHECK_CITY);
        if (state.city) return false;

        return this.rootApi.getDefaultCity().then((response) => {
            commit(types.SET_CITY, response);
        });
    },
    getCart({ commit }) {
        return this.cartApi.getCart().then((response) => {
            commit(types.SET_CART, response);
        });
    },
    resetCart({ commit }) {
        commit("RESET_CART");
    },
    addProductInCart({ commit }, { quantity, productId }) {
        commit(types.HIDE_FREE_DELIVERY_MODAL);

        return this.cartApi.addCart({ quantity, productId }).then((response) => {
            commit(types.SET_CART, response);
            commit(types.SHOW_FREE_DELIVERY_MODAL);
            return response;
        });
    },
    removeProductInCart({ commit }, { quantity, productId }) {
        return this.cartApi.changeQuantityCart({ quantity, productId }).then((response) => {
            commit(types.SET_CART, response);
        });
    },
    getBanners({ commit }) {
        return this.optionalApi.getBanners().then((response) => {
            commit(types.SET_BANNERS, response);
        });
    },
    getMedia({ commit }, payload = {}) {
        return this.optionalApi.getMediaAboutUs(payload.perPage).then((response) => {
            commit(types.SET_MEDIA, response);
        });
    },
    getBrands({ commit }) {
        return this.optionalApi.getWhereBuy().then((response) => {
            commit(types.SET_BRANDS, response);
        });
    },
    getCatalog({ commit }, payload = {}) {
        if (!payload.isPaginated) {
            commit("RESET_CATALOG");
        }
        commit("START_CATALOG_LOADING");
        return this.productsApi.getCatalog(payload.query, payload.sorts).then((response) => {
            commit(types.SET_CATALOG_PAGINATION, {
                currentPage: response.currentPage,
                lastPage: response.lastPage,
            });
            commit(types.SET_CATALOG, {
                items: response.products,
                isPaginated: payload.isPaginated,
            });
            commit("STOP_CATALOG_LOADING");
            return response;
        });
    },
    getAllCatalog({ commit }, query) {
        return this.productsApi.getAllCatalog(query).then((response) => {
            response.items = response.items.sort((a, b) => a.eol - b.eol);
            commit(types.SET_ALL_CATALOG, response);
        });
    },
    getCategories({ commit }, seriesId) {
        return this.productsApi.getCategories(seriesId).then((response) => {
            commit(types.SET_CATEGORIES, response);
        });
    },
    setNewCity({ commit }, { cityName }) {
        commit(types.SET_CITY, { cityName });
    },
    getFaqSections({ commit }) {
        return this.optionalApi.getFaqSections().then((response) => {
            commit(types.SET_FAQ_SECTIONS, response);
        });
    },
    getFaqElements({ commit }) {
        return this.optionalApi.getFaqElements().then((response) => {
            commit(types.SET_FAQ_ELEMENTS, response);
        });
    },
    getOnlinePaymentStatus({ commit }, { orderId }) {
        return this.rootApi.getOnlinePaymentStatus({ orderId }).then((response) => {
            commit(types.SET_ONLINE_PAYMENT_STATUS, response);
        });
    },
};

const getters = {
    productsInCartIds(state) {
        if (state.cart?.productsList) {
            return Object.values(state.cart.productsList).map((product) => {
                return product.id;
            });
        }
        return [];
    },
    currency(state) {
        if (state.site?.currency?.code) {
            return CURRENCY_SIGN[state.site.currency.code];
        }
        return "₽";
    },
    currencyCode(state) {
        return state.site?.currency?.code;
    },
    filteredFaq(state) {
        return state.faqSections.map((section) => {
            const children = section.children.map((child) => {
                return {
                    ...child,
                    elements: state.faqElements.filter((el) => el.sectionId === child.id),
                };
            });

            return {
                id: section.id,
                name: section.name,
                image: section.image,
                children,
                elements: state.faqElements.filter((el) => el.sectionId === section.id),
            };
        });
    },
};

const CURRENCY_SIGN = {
    RUB: "₽",
    KZT: "₸",
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
